import { useState } from 'react';
import { faqData } from '@/mocks/sports';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">快速了解bb体育平台的常见疑问</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-label font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}